import Swiper from "swiper/bundle";

function initFeaturesCarousel(root = document) {
    const swipers = root.querySelectorAll(".block-features__swiper");

    swipers.forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        if (!el.querySelector(".swiper-slide")) {
            return;
        }

        new Swiper(el, {
            slidesPerView: 1.15,
            slidesOffsetBefore: 16,
            spaceBetween: 20,
            watchOverflow: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            breakpoints: {
                576: {
                    slidesPerView: 1.35,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 30
                },
            }
        });
    });
}

export { initFeaturesCarousel };
